export const i18n = {
  de: {
    buttons: {
      validate: 'validieren',
      generate: 'generieren',
      regenerate: 'neu generieren',
      reset: 'alles löschen',
      close: 'schließen',
    },
    settings: {
      operation: {
        title: 'Matmathische Operation',
        add: 'plus',
        substract: 'minus',
        multiply: 'mal',
        divide: 'geteilt',
        copy: '',
      },
      amountOfEntries: {
        title: 'Anzahl der Aufgaben',
        copy: '',
      },
      mode: {
        title: 'Modus',
        normal: 'normal',
        hard: 'hart',
        copy: 'Der Modus "hart" ist noch schwieriger. Die Aufgabe wird nicht im Ergebnis-Kächeln eingegeben, sondern in einer der ersten zwei Komponenten. Z.B. die Aufgabe "10 + 6 = ___" wird zu "10 + ___ = 16"',
      },
      range: {
        title: 'nur Zahlen bis',
        copy: 'Die Aufgaben werden höchstens bis zu der definierten Zahl erstellt. Z.B. bei plus Aufgaben mit "nur Zahlen bis" 20, werden nur Aufgaben erstellt, welche die zwei zu addierenden Zahlen von 0 bis 20 sein können.',
      },
      baseFactor: {
        title: 'einmaleins Zahl (1 bis 9)',
        copy: 'Wenn gesetzt, wird diese Zahl für die einmaleins oder als geteilt Faktor benutzt. Z.B. die "einmaleins Zahl" 5, erstellt nur einmaleins oder geteilt Afgaben mit der Zahl 5',
      },
    },
  },
  en: {
    buttons: {
      validate: 'validate',
      generate: 'generate',
      regenerate: 'regenerate',
      reset: 'reset',
      close: 'close',
    },
    settings: {
      operation: {
        title: 'mathematical operation',
        add: 'plus',
        substract: 'minus',
        multiply: 'multiply',
        divide: 'divide',
        copy: '',
      },
      amountOfEntries: {
        title: 'Amount of entries',
        copy: '',
      },
      mode: {
        title: 'Mode',
        normal: 'normal',
        hard: 'hard',
        copy: ' The "hard" ode is more difficult. The input entry to solve is not in the result position, but randomly the first or the second component of the mathemtic operation. E.g. "10 + 6 = ___" will become "10 + ___ = 16"',
      },
      range: {
        title: 'only numbers up to',
        copy: 'If set, it will create entries with a numbers up to the selected number for the first and the second component of the mathemathical operation. E.g. for plus entires with "only numbers up to" 20, will create entries where the two numbers to add will be created randomly with numbers up to 20.',
      },
      baseFactor: {
        title: 'base factor',
        copy: 'If set, this number will be used as base factor for multiplication or division.',
      },
    },
  },
  es: {
    buttons: {
      validate: 'validar',
      generate: 'generar',
      regenerate: 'regenerar',
      reset: 'borrar todo',
      close: 'cerrar',
    },
    settings: {
      operation: {
        title: 'oepración matemática',
        add: 'sumar',
        substract: 'restar',
        multiply: 'multiplicar',
        divide: 'dividir',
        copy: '',
      },
      amountOfEntries: {
        title: 'Cantidad de ejercicios',
        copy: '',
      },
      mode: {
        title: 'modo',
        normal: 'normal',
        hard: 'difícil',
        copy: 'El modo "difícil" es mas complicado. El ejercicio a resolver no es el resultado de la operación sino que aleatóriaente el primer o segundo componente de la operación matemática. Por ejemplo "10 + 6 = ___" será "10 + ___ = 16"',
      },
      range: {
        title: 'solo números hasta',
        copy: 'Genera números aleatorios hasta como máximo el número seleccionado para los primeros dos componentes de la operación matemática. Por ejemplo oara "solo números hasta" 20, genera ejercicios dónde los primeros dos componentes de la operación matemática serán números aleatorios como máximo el número 20.',
      },
      baseFactor: {
        title: 'múltiplo o divisor base',
        copy: 'Si es definido, será el múltiplo o divisor a utilizar para la operación matemática (para multiplicación y división respectivamente).',
      },
    },
  },
};
